import { SvgIcon } from '@mui/material';
import { forwardRef } from 'react';
import SysLocation from './SystemLocation.svg';

export const SystemLocation = forwardRef(function SystemLocation(props, ref) {
  return (
    <SvgIcon {...props} ref={ref} component={SysLocation} viewBox="0 0 40 41" />
  );
});
